// extracted by mini-css-extract-plugin
export default {"homeFooter":"HomeFooter_homeFooter__06WZ7","homeFooter__btn":"HomeFooter_homeFooter__btn__yJ2h5","homeFooter__iconImg":"HomeFooter_homeFooter__iconImg__ipsAF"};